import { QRAGraphType } from 'features/RiskManagement/Components/Graphs'
import GraphContainerCard from 'features/RiskManagement/Components/Graphs/Components/GraphContainerCard'
import { graphTypeToName } from 'features/RiskManagement/Components/Graphs/Utils/graphTypeToName'

interface INoDataCard {
  graphType: QRAGraphType
}

const NoDataChart = ({ graphType }: INoDataCard) => {
  // US.18 RQ.10
  const message =
    'No data available for the selected filters. Please edit the filters.'

  return (
    <GraphContainerCard title={graphTypeToName(graphType)}>
      <div className='flex h-full items-center justify-center text-center'>
        {message}
      </div>
    </GraphContainerCard>
  )
}

export default NoDataChart
